// extracted by mini-css-extract-plugin
export var container = "projects-module--container--47ZU1";
export var pic = "projects-module--pic--t51eT";